import React from "react";

const Steps = () => {
  return (
    <div
      className="container-fluid steps py-5"
      style={{ backgroundColor: "#007bff" }}
    >
      <div className="container py-5">
        <div
          className="text-center mx-auto pb-5 wow fadeInUp"
          data-wow-delay="0.1s"
          style={{ maxWidth: "800px" }}
        >
          <h1 className="display-5 text-capitalize text-white mb-3">
            Our <span className="text-primary">Rental Process</span>
          </h1>
          <p className="mb-0 text-white">
            Experience a seamless car rental process with Steward Cars. From
            booking to driving, we ensure your journey is hassle-free!
          </p>
        </div>
        <div className="row g-4">
          <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.1s">
            <div className="steps-item p-4 mb-4">
              <h4>Contact Us</h4>
              <p className="mb-0">
                Reach out via phone or our website. Our friendly team is ready
                to assist you with your rental needs!
              </p>
              <div className="steps-number">01.</div>
            </div>
          </div>
          <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.3s">
            <div className="steps-item p-4 mb-4">
              <h4>Choose Your Car</h4>
              <p className="mb-0">
                Browse our diverse fleet and select the perfect vehicle that
                suits your travel plans and preferences.
              </p>
              <div className="steps-number">02.</div>
            </div>
          </div>
          <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
            <div className="steps-item p-4 mb-4">
              <h4>Hit the Road</h4>
              <p className="mb-0">
                Enjoy your journey with our reliable cars. Experience Kenya like
                never before!
              </p>
              <div className="steps-number">03.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;
